import axios from '../utils/axios';

export default function fetchAssignees(adminId) {
    return (
        axios.get(`/admin/${adminId}/assignees`, { })
    )
}
